import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon, CheckIcon } from 'lucide-react';
export function Tomos() {
  const bullets = ['Material imprimible para aplicar de inmediato', 'Actividades pensadas para diferentes perfiles de niños', 'Herramientas listas para organizar e intervenir mejor'];
  return <section className="w-full py-12 md:py-16 bg-transparent font-['Open_Sans',_sans-serif]" data-id="element-220">
      <div className="max-w-2xl mx-auto px-4 md:px-6" data-id="element-221">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        amount: 0.2
      }} transition={{
        duration: 0.6,
        ease: [0.22, 1, 0.36, 1]
      }} className="relative rounded-3xl border border-[#C084FC]/25 bg-gradient-to-b from-[#161616] to-[#0F0F0F] p-6 md:p-9 shadow-[0_0_40px_rgba(192,132,252,0.08)] overflow-hidden" data-id="element-222">
          {/* Soft glow accent top */}
          <div className="absolute top-0 left-1/2 -translate-x-1/2 w-2/3 h-px bg-gradient-to-r from-transparent via-[#C084FC]/40 to-transparent" data-id="element-223" />

          {/* Top row: icon + INCLUIDO badge */}
          <div className="flex items-start justify-between mb-6" data-id="element-224">
            <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-[#C084FC]/15 border border-[#C084FC]/30 flex items-center justify-center" data-id="element-225">
              <BookOpenIcon className="w-7 h-7 md:w-8 md:h-8 text-[#D8B4FE]" data-id="element-226" />
            </div>
            <div className="inline-flex items-center gap-1.5 bg-[#C084FC]/10 border border-[#C084FC]/40 rounded-full px-3 py-1.5" data-id="element-227">
              <CheckIcon className="w-3 h-3 text-[#C084FC]" strokeWidth={3} data-id="element-228" />
              <span className="text-[10px] font-bold uppercase tracking-[0.2em] text-[#D8B4FE]" data-id="element-229">
                Incluido
              </span>
            </div>
          </div>

          {/* Title */}
          <h3 className="text-2xl md:text-3xl font-[900] text-white tracking-tight leading-tight mb-2" data-id="element-230">
            6 Tomos · Intervención + Organización
          </h3>

          {/* Value row */}
          <p className="text-sm md:text-base text-gray-400 mb-5" data-id="element-231">
            Valor: <span className="line-through text-gray-500" data-id="element-232">$84.950</span> ·{' '}
            <span className="text-[#D8B4FE] font-semibold" data-id="element-233">Hoy:</span>{' '}
            <span className="text-[#C084FC] font-bold" data-id="element-234">Gratis con el Kit</span>
          </p>

          {/* Description */}
          <p className="text-sm md:text-base text-gray-300 leading-relaxed mb-7" data-id="element-235">
            El pack que te resuelve tus sesiones de todo el año — simple,
            práctico y completo.
          </p>

          {/* Divider */}
          <div className="h-px bg-gradient-to-r from-transparent via-white/10 to-transparent mb-6" data-id="element-236" />

          {/* Bullets */}
          <ul className="space-y-3.5" data-id="element-237">
            {bullets.map((bullet, i) => <li key={i} className="flex items-start gap-3" data-id="element-238">
                <span className="flex-shrink-0 inline-flex items-center justify-center w-5 h-5 rounded-full bg-[#C084FC]/15 border border-[#C084FC]/40 mt-0.5" data-id="element-239">
                  <CheckIcon className="w-3 h-3 text-[#C084FC]" strokeWidth={3} data-id="element-240" />
                </span>
                <span className="text-[14px] md:text-[15px] text-gray-200 leading-relaxed" data-id="element-241">
                  {bullet}
                </span>
              </li>)}
          </ul>
        </motion.div>
      </div>
    </section>;
}